import React__default from 'react';
var PopoverContext = React__default.createContext({
  onClose: function onClose() {}
});
var usePopoverContext = function usePopoverContext() {
  return React__default.useContext(PopoverContext);
};
export { PopoverContext, usePopoverContext };